import { CABLE_TOUCHSTONE, CONNECTOR_TOUCHSTONE, GENERIC_TOUCHSTONE, PCB_TOUCHSTONE, PKG_TOUCHSTONE, SPICE } from "../../../../constants/libraryConstants";

const CONNECTOR = "Connector", PACKAGE = "Package", PCB = "PCB", CABLE = "Cable", INTERPOSER = 'Interposer', DIE = "DIE", NEW_MODEL = "NewModel", EDIT_MODEL = "EditModel";
const PACKAGE_DIE = "Package_DIE";
const dropdownMenuItems = [
  { label: CONNECTOR + ' Model', key: CONNECTOR },
  { label: PACKAGE + ' Model', key: PACKAGE },
  { label: PCB + ' Model', key: PCB },
  { label: CABLE + ' Model', key: CABLE }
]

const dropdownMenuItemsObj = {
  default: dropdownMenuItems,
  [PACKAGE_DIE]: [
    ...dropdownMenuItems,
    { label: INTERPOSER + ' Model', key: INTERPOSER }
  ]
}

const netToPinType = {
  nets_P: 'positive',
  nets_N: 'negative',
  nets_A: 'Line A',
  nets_B: 'Line B',
  nets_C: 'Line C'
}

const DIE_TERMINATION = "DIE termination";
const PARALLEL = 'parallel', SERIES = 'series';

// modelType -> Library type
const modelTypeToLibrarys = {
  [CONNECTOR]: [CONNECTOR_TOUCHSTONE],
  [PACKAGE]: [PKG_TOUCHSTONE],
  [PCB]: [PCB_TOUCHSTONE],
  [CABLE]: [CABLE_TOUCHSTONE],
  Generic: [GENERIC_TOUCHSTONE, SPICE]
}

const channelModelTypes = [CONNECTOR_TOUCHSTONE, PKG_TOUCHSTONE, PCB_TOUCHSTONE, CABLE_TOUCHSTONE, GENERIC_TOUCHSTONE, SPICE];

const colorPalette = {
  yellow: ["#FFFACD", "#FFFFE0", "#FFFFF0"],
  green: ['#EBFFF5', '#F5FFF7', '#E9FFE1', '#E1FFE1'],
  blue: ["#D4F1F9", "#E6F3FF", "#f0f5ff", "#E6F4FF"],
  purple: ["#E6E6FA", "#F0E6FF", "#F5F0FF", "#f9f0ff"],
  pink: ["#FFECF0", "#FFE4E9", "#FFF0F5"],
  orange: ["#FFE4CC", "#FFEFD5", "#FFF5E6"],
  cyan: ["#E0FFFF", "#F0FFFF", "#E6FFFB", "#F5FFFA"]
}
export {
  dropdownMenuItems,
  dropdownMenuItemsObj,
  NEW_MODEL,
  EDIT_MODEL,
  netToPinType,
  PACKAGE_DIE,
  DIE,
  INTERPOSER,
  PARALLEL,
  SERIES,
  DIE_TERMINATION,
  modelTypeToLibrarys,
  channelModelTypes,
  colorPalette
}